<template>
  <div id="faultOffer">
    <el-row>
      <el-col :span="6">
        <el-row>
          <el-col>
            <ul class="clearfix" style="margin-bottom: 15px;">
              <span class="headerSpan">品牌</span>
              <li class="fl listPart" v-for="(item,index) in brandLists" :key="index" @click="selectBrand(item,index)" v-bind:class="{active:activeBrandIndex===index}">{{item.brandName}}</li>
            </ul>
            <ul class="clearfix" style="margin-bottom: 15px;">
              <span class="headerSpan">品类</span>
              <li @click="selectCategory(item,index)" class="fl listPart" v-for="(item,index) in categoryLists" :key="index" v-bind:class="{active:activeCategoryIndex===index}">{{item.categoryName}}</li>
            </ul>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="18">
        <el-button v-show="!showText" type="success" v-if="faultAuth.saveTable" size="medium" @click="exitTable()" style="margin-bottom: 15px;">编辑</el-button>
        <el-button v-show="showText" type="success" size="medium" @click="saveTable()" style="margin-left: 0px;margin-bottom: 15px;">
          保存
        </el-button>
        <el-table :data="tableData3">
          <el-table-column label="故障" align="right" >
            <el-table-column prop="modelName" label="型号" width="120">
            </el-table-column>
          </el-table-column>
          <el-table-column align="center"  v-for="(item,index) of testData" :key="index" :label="item.faultTypesName">
            <el-table-column :label="m.faultSubclassName" align="center" v-for="m,j in item.faultSubclasses" :key="j">
              	<template slot-scope="scope">
	                <span v-if="scope.row.faultSubclassId !== m.faultSubclassId || scope.row.price == null">-</span>
	                <span v-else-if="showText == false && scope.row.price !== null">{{scope.row.price}} </span>
	                <el-input v-else-if="showText == true && scope.row.price !== null" v-model.trim="scope.row.price"></el-input>
	                <!-- <span v-else>-</span> -->
              	</template>
            </el-table-column>
          </el-table-column>
      </el-table>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  let moment = require("moment");
  import {getPermission} from '../../api/authRequest'
  import {
    insertFaultSolutionPrice,selectFaultSolutionPrice,selectSolution,selectModelFaultTypes,selectAllBrand,selectCategory,insertModelFaultSolution,selectModelFaultSolution,deleteModelFaultSolution,exportModelFaultSolution,
  } from "../../api/api";
  export default {
    name: 'faultOffer',
    components: {
    },
    data () {
      return {
        updateUser:'',
        roleTime:'',
        userInfoForm:{},
        showText:false,
        tableData3: [],
        defaultBrandId:'',
        defaultCategoryId:'',
        brandLists:'',
        categoryLists:'',
        activeBrandIndex:"",
        activeCategoryIndex:"",
        testData:[],
        saveData:[],
        faultAuth:{
          	saveTable:false
        }
      }
    },
    mounted () {
      this.getModelFaultTypesList();
      this.getBrandLists();
      this.faultAuth.saveTable= getPermission('/api/basicSetting/ModelFaultSolution/insertFaultSolutionPrice');
      //获取用户信息
      var userInfoStr = localStorage.getItem('userInfo');
      this.userInfoForm = JSON.parse(userInfoStr);
      this.updateUser = this.userInfoForm.updateUser
    },
    methods: {
      //获取故障大类故障小类
      getModelFaultTypesList(){
        selectModelFaultTypes().then(res => {
          if (res.data.status == 100) {
            this.testData = res.data.results
            //console.log(this.testData)
          } else {
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        }).catch((error) => {
          this.$Message.error(error.message);
        })
      },
      //查询品牌品类维修方式价格
      getSolutionPrice(){
        let para = {
          brandId:this.defaultBrandId,
          categoryId:this.defaultCategoryId,
        }
        selectFaultSolutionPrice(para).then(res => {
          if (res.data.status==100) {
            this.tableData3 = res.data.results
            console.log(this.tableData3)
          }
        }).catch((error) =>{
          this.$Message.error(error.message);
        })
      },
      //查询品牌or获取品牌
      getBrandLists() {
        selectAllBrand().then(res => {
          if (res.data.status==100) {
            this.brandLists = res.data.results
          }else{
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        }).catch((error) =>{
          this.$Message.error(error.message);
        })
      },
      //选中品牌
      selectBrand(item,index) {
        this.activeBrandIndex = index
        this.defaultBrandId = Object.assign({}, item).brandId
        this.getCategoryList(this.defaultBrandId)
      },
      //获取品类
      getCategoryList(id){
        const brandId = id
        const brandData = {brandId:brandId}
        selectCategory(brandData).then((res) => {
          if (res.data.status == 100) {
            this.categoryLists = res.data.results
          }else{
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        }).catch((error) => {
          this.$Message.error(error.message);
        })
      },
      //选中品类
      selectCategory(item,index) {
        this.activeCategoryIndex = index
        this.defaultCategoryId = Object.assign({}, item).categoryId
        this.getSolutionPrice()
      },
      exitTable(){
        this.showText = true
      },
      saveTable(){
        const nowTime = new Date();
        this.roleTime = moment(nowTime).format("YYYY-MM-DD");
        for(var i in this.tableData3){
          this.tableData3[i].updateUser=this.updateUser;
          this.tableData3[i].updateTime=this.roleTime;
        }
        // console.log(this.tableData3)
        let para = this.tableData3
        insertFaultSolutionPrice(para).then(res => {
          if (res.data.status==100) {
            this.$message({
              message: res.data.message,
              type: "success"
            });

            /*刷新*/
            this.getSolutionPrice();
          }else{
             this.$message({
                message: res.data.message,
                type: "error"
              });
          }
        }).catch((error) =>{
          this.$Message.error(error.message);
        })
        this.showText = false
      }
    },
    computed: {
    },
    watch: {

    }
  }
</script>

<style lang="scss" type="text/css" scoped>
  @import '../../assets/css/base.css';
  /*@import '../node_modules/iview/dist/styles/iview.css';*/
  #faultOffer{
    font-size: 14px;
    .headerT{font-size: 16px;margin:0 0 15px 0;}
    .headerSpan{margin-right: 20px;display: block;}
    .listPart{border:1px solid #c6c6c6;margin:10px 15px 10px 0;border-radius: 5px;text-align: center;position: relative;z-index: 0;cursor: pointer;padding: 5px 10px;}
    li.active{background-color:#1abc9c;color:#fff;border-color: #1abc9c;}
    .el-checkbox.is-bordered+.el-checkbox.is-bordered {
      margin-left: 15px;
    }
    .el-table td, .el-table th {padding:10px 0;}
    .el-table thead.is-group th { background: none; }
    .el-table thead.is-group tr:first-of-type th:first-of-type { border-bottom: none; }
    .el-table thead.is-group tr:first-of-type th:first-of-type:before {
      content: '';
      position: absolute;
      width: 1px;
      height: 75px; /*这里需要自己调整，根据td的宽度和高度*/
      top: 0;
      left: 0;
      background-color: grey;
      opacity: 0.3;
      display: block;
      transform: rotate(-53deg); /*这里需要自己调整，根据线的位置*/
      transform-origin: top;
      }
      .el-table thead.is-group tr:last-of-type th:first-of-type:before {
        content: '';
        position: absolute;
        width: 1px;
        height: 75px; /*这里需要自己调整，根据td的宽度和高度*/
        bottom: 0;
        right: 2px;
        background-color: grey;
        opacity: 0.3;
        display: block;
        transform: rotate(-53deg); /*这里需要自己调整，根据线的位置*/
        transform-origin: bottom;
         /*//background:red; */
      }

  }


</style>



// WEBPACK FOOTER //
// faultOffer.vue?ccabf878